import { useMenuStore } from '@/stores/menu';
import { useAppStore } from '@/stores/app';
import { MarketType, Platform } from '@/constants';
import { getPlatform } from '@/helpers/getPlatform';
import { successMessage } from '@/helpers/message';
import i18n from '@/plugins/i18n';

const utils = {
    isMobile() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            return true;
        }

        return false;
    },
    lowerCaseFirstOnlyLetter: (string) => string[0].toLowerCase() + string.slice(1),
    updateBreadcrumbs: function (currentLink) {
        const menuStore = useMenuStore();
        let breadCrumbs = [];

        menuStore.navMenuItems.map(function (menuItem) {
            if (menuItem.subItems) {
                menuItem.subItems.map(function (subMenuItem) {
                    if (subMenuItem.link === currentLink) {
                        breadCrumbs.push({
                            text: menuItem.title,
                            disabled: false,
                        });

                        let title = subMenuItem.breadcrumb ? subMenuItem.breadcrumb : subMenuItem.title;
                        breadCrumbs.push({ text: title, disabled: false });
                    }
                });
            } else if (menuItem.link && menuItem.link === currentLink) {
                breadCrumbs.push({ text: menuItem.title, disabled: false });
            }
        });

        if (!breadCrumbs.length) {
            breadCrumbs.push({ text: currentLink, disabled: false });
        }

        menuStore.setBreadcrumbs(breadCrumbs);
    },

    isEmpty: function (v) {
        return !v && parseInt(v) !== 0;
    },
    isEmail: function (v) {
        return String(v)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    },
    isNumeric: function (v) {
        return /^-?\d+$/.test(v);
    },

    isSkipJsValidation() {
        return JSON.parse(localStorage.getItem('app'))?.skipJsValidation ?? false;
    },
};

export function copyToClipboard(text) {
    if (text) {
        navigator.clipboard.writeText(text);
        successMessage(i18n.global.t('common.copiedToClipboard'));
    }
}
export default utils;
